module.exports = __webpack_public_path__ + "img/footer-logos.18a0629e.png";